export default function LoadingPage() {
    return (
        <div
            className="loading-page"
            style={{
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                justifyContent: "center",
            }}
        >
            Loading...
        </div>
    );
}
